/**
 *
 * Setting.mixin
 *
 */

import { mapActions, mapState, mapGetters } from 'vuex';
import _ from 'lodash';

import { RE_NUMBER, RE_LETTER, RE_EMAIL, HALF_DEBOUNCE_LATENCY } from '@/constants/index';

export const SettingMixin = {
  name: 'SettingMixin',

  data: () => {
    return {
      nickname: '',
      errMessageNickname: '',
      //
      newPassword: '',
      isShowNewPasswordInvalid: false,
      errMessageNewPassword: '',
      isShowNewPassword: false,
      //
      email: '',
      isShowEmailInvalid: false,
      isEmailDuplicate: false,
      isEmailServerChecked: false,
      errMessageEmail: '',
      //
      wechat: '',
      errMessageWechat: '',
      //
      isQrCodeHandled: '',
      itvlcheckWechatQrcode: null,
    };
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_hasEmail() {
      return (
        this.mg_userInfo.email &&
        this.mg_userInfo.email.indexOf('@pzacademytemp.pz') == -1 &&
        this.mg_userInfo.email.indexOf('@pzacademy.pz') == -1
      );
    },

    c_hasPassword() {
      return this.c_hasEmail || (this.mg_userInfo.profile && this.mg_userInfo.profile.passwordAes);
    },

    c_hasWechatNo() {
      return this.mg_userInfo.wechat;
    },

    c_hasMobile() {
      return this.mg_userInfo.mobile;
    },

    ...mapState('Mixins/Setting', {
      ms_setting_mixin_isRequest: 'isRequest',
      ms_isNicknameCheckExistRequest: 'isNicknameCheckExistRequest',
      ms_isNicknameIsUnique: 'isNicknameIsUnique',
      ms_isNicknameMatchFormat: 'isNicknameMatchFormat',
      ms_countries: 'countries',
      //
      ms_wechatQrcodeInfo: 'wechatQrcodeInfo',
    }),

    c_isNicknameFilled() {
      return this.nickname;
    },

    c_isShowNotNicknameMatchFormat() {
      return this.c_isNicknameFilled && !this.ms_isNicknameMatchFormat;
    },

    c_isShowNotNicknameIsUnique() {
      return (
        this.c_isNicknameFilled &&
        !this.ms_isNicknameIsUnique &&
        !this.c_isShowNotNicknameMatchFormat
      );
    },

    _c_isNicknameReady() {
      return this.c_isNicknameFilled && this.ms_isNicknameMatchFormat;
    },

    c_isNicknameReady() {
      return this._c_isNicknameReady;
    },

    //
    c_isNewPasswordFilled() {
      return this.newPassword;
    },

    c_isNewPasswordInvalid() {
      if (this.c_isNewPasswordFilled) {
        if (
          !RE_NUMBER.test(this.newPassword) ||
          !RE_LETTER.test(this.newPassword) ||
          this.newPassword.length < 8
        ) {
          return true;
        }
      }
      return false;
    },

    c_isShowNewPasswordInvalid() {
      return this.c_isNewPasswordFilled && this.isShowNewPasswordInvalid;
    },

    c_isNewPasswordReady() {
      return this.c_isNewPasswordFilled && !this.c_isNewPasswordInvalid;
    },

    //
    c_isEmailFilled() {
      return this.email;
    },

    c_isEmailInvalid() {
      if (this.c_isEmailFilled) {
        if (!RE_EMAIL.test(this.email)) {
          return true;
        }
      }
      return false;
    },

    c_isShowEmailInvalid() {
      return this.c_isEmailFilled && this.isShowEmailInvalid;
    },

    c_isEmailReady() {
      return (
        this.c_isEmailFilled &&
        !this.c_isEmailInvalid &&
        !this.isEmailDuplicate &&
        this.isEmailServerChecked
      );
    },

    //
    c_isWechatToolong() {
      return this.wechat && this.wechat.length > 50;
    },

    c_isWechatReady() {
      return this.wechat && !this.c_isWechatToolong;
    },

    //
    c_isQrcodeTimeout() {
      return 'timeout' === this.isQrCodeHandled;
    },
  },

  watch: {},

  methods: {
    ...mapActions('Mixins/Setting', {
      ma_checkExistNickname: 'checkExistNickname',
      ma_getMallCountries: 'getMallCountries',
      ma_validateEmail: 'validateEmail',
      ma_prepurchaseFromWechat: 'prepurchaseFromWechat',
      ma_prepurchaseFromEmail: 'prepurchaseFromEmail',
      //
      ma_getWechatQrcode: 'getWechatQrcode',
    }),

    //
    async _checkInputNickname() {
      if ('' !== this.nickname) {
        await this.ma_checkExistNickname({
          nickname: this.nickname,
        });
      }
    },

    handleInputNickname() {
      this.errMessageNickname = '';
      this.de_checkInputNickname();
    },

    //
    _checkInputNewPassword() {
      if (this.c_isNewPasswordInvalid) {
        this.isShowNewPasswordInvalid = true;
      }
    },

    handleInputNewPassword() {
      this.errMessageNewPassword = '';
      this.isShowNewPasswordInvalid = false;
      this.de_checkInputNewPassword();
    },

    toggleNewPassword() {
      this.isShowNewPassword = !this.isShowNewPassword;
    },

    //
    async _checkInputEmail() {
      if (this.c_isEmailFilled) {
        if (this.c_isEmailInvalid) {
          this.isShowEmailInvalid = true;
          this.errMessageEmail = '邮箱地址格式不正确';
        } else {
          const res = await this.ma_validateEmail(this.email.toLowerCase());
          this.isEmailDuplicate = !res.data.data;
          this.isEmailServerChecked = true;
        }
      }
    },

    handleInputEmail() {
      this.errMessageEmail = '';
      this.isShowEmailInvalid = false;
      this.isEmailDuplicate = false;
      this.isEmailServerChecked = false;
      this.de_checkInputEmail();
    },

    //
    async _getWechatQrcode() {
      const res = await this.ma_getWechatQrcode();
      return res;
    },

    async getWechatQrcode() {
      this.isQrCodeHandled = '';
      const res = await this._getWechatQrcode();
      return res;
    },

    checkWechatQrcode() {
      //
    },

    checkWechatQrcodeAndSetItvl() {
      this.itvlcheckWechatQrcode = setInterval(() => {
        this.checkWechatQrcode();
      }, 2000);
    },

    stopCheckWechatQrcode() {
      this.isQrCodeHandled = 'cancel';
      clearInterval(this.itvlcheckWechatQrcode);
    },

    async refreshWechatQrcode() {
      this.isQrCodeHandled = '';
      clearInterval(this.itvlcheckWechatQrcode);
      await this._getWechatQrcode();
      this.checkWechatQrcodeAndSetItvl();
    },
  },

  created() {
    this.de_checkInputNickname = _.debounce(this._checkInputNickname, HALF_DEBOUNCE_LATENCY);
    this.de_checkInputNewPassword = _.debounce(this._checkInputNewPassword, HALF_DEBOUNCE_LATENCY);
    this.de_checkInputEmail = _.debounce(this._checkInputEmail, HALF_DEBOUNCE_LATENCY);
  },

  beforeDestroy() {
    clearInterval(this.itvlcheckWechatQrcode);
  },
};

export default SettingMixin;
